import { isNil } from 'lodash';
import { REX_ADD_TEXT_FOR_NUMBER } from '../rex';

export const makeNumberWithComma = (value: number, unit?: string) => {
  if (isNil(value)) return '-';

  let result = value.toString().replace(REX_ADD_TEXT_FOR_NUMBER, ',');

  if (unit) result += unit;

  return result;
};
